export const COMPANY_SELECTION_ROLES = [
  'BONO_ACCOUNT_MANAGER',
  'BONO_SUPER_ADMIN',
  'PARTNER_USER',
  'PARTNER_ADMIN'
] as const;

export const PARTNER_ROLES = [
  'PARTNER_USER',
  'PARTNER_ADMIN',
  'PARTNER_READ_ONLY'
] as const;

export const SWITCH_APP_ROLES = [
  'BONO_ACCOUNT_MANAGER',
  'BONO_SUPER_ADMIN',
  'PARTNER_USER',
  'PARTNER_ADMIN'
] as const;

export const CARBON_ACCOUNTING_ROLES = [
  'CARBON_ACCOUNTING_USER',
  'CARBON_ACCOUNTING_ADMIN',
  'CARBON_ACCOUNTING_READ_ONLY',
  'CARBON_ACCOUNTING_FACILITY_DATA_ENTRY'
] as const;

export const SUPPLY_CHAIN_ROLES = [
  'SUPPLY_CHAIN_USER',
  'SUPPLY_CHAIN_ADMIN'
] as const;

export const APPLICATION_TYPES_CONST = {
  CARBON_ACCOUNTING: 'CARBON_ACCOUNTING',
  SUPPLY_CHAIN: 'SUPPLY_CHAIN',
  VENDOR: 'VENDOR',
  MARKETPLACE: 'MARKETPLACE'
} as const;

export const APPLICATION_STATUS_CONST = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  PENDING: 'PENDING',
  TERMINATED: 'TERMINATED'
} as const;